import {UcoastEl} from "@/scripts/core/UcoastEl";
import { qsRequired } from '@/scripts/core/global'
import { type CartDrawerItems } from '@/scripts/cart/CartDrawerItems'
import { type QuantityInput } from '@/scripts/product/QuantityInput'

export class CartRemoveButton extends UcoastEl {
	static htmlSelector = 'cart-remove-button';
	constructor() {
		super();
		const button = qsRequired<HTMLButtonElement>('button', this);
		button.addEventListener('click', (event) => {
			event.preventDefault();
			const quantityEl = this.getRelatedQuantityEl()
			quantityEl.onCloseButtonClick(event);

		});
	}
	getCartItems() {
		return qsRequired<CartDrawerItems>('cart-drawer-items');
	}
	getRelatedQuantityEl(): QuantityInput {
		return qsRequired<QuantityInput>(`quantity-input[data-index="${this.dataset.index}"]`, this.getCartItems());
	}
}
